export var TimerType;
(function (TimerType) {
    TimerType[TimerType["Timeout"] = 0] = "Timeout";
    TimerType[TimerType["Interval"] = 1] = "Interval";
})(TimerType || (TimerType = {}));
/*
 * Wraps window.setTimeout and window.clearTimeout and allows cancel and trigger
 */
export class Timer {
    constructor() {
        this.timerType = TimerType.Timeout;
    }
    setup(timeoutHandler, delay, timerType = TimerType.Timeout, debugMessage) {
        if (this.timerHandler === timeoutHandler) {
            // already set
            return;
        }
        if (this.timerHandler !== undefined) {
            throw new Error("[Timer] You already setup a timer!");
        }
        this.timerType = timerType;
        this.timerHandler = timeoutHandler;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const timer = this;
        if (this.timerType === TimerType.Timeout) {
            this.timerId = self.setTimeout(() => {
                (debugMessage !== undefined) && this.debugLog(debugMessage);
                timer.trigger();
            }, delay);
        }
        else {
            this.timerId = self.setInterval(() => {
                (debugMessage !== undefined) && this.debugLog(debugMessage);
                timer.trigger();
            }, delay);
        }
    }
    cancel(messageOnCancel) {
        if (this.timerId === undefined)
            return;
        this.debugLog(messageOnCancel);
        if (this.timerType === TimerType.Timeout) {
            self.clearTimeout(this.timerId);
        }
        else {
            self.clearInterval(this.timerId);
        }
        this.timerHandler = undefined;
        this.timerId = undefined;
    }
    trigger() {
        this.timerHandler && this.timerHandler();
        if (this.timerType === TimerType.Timeout) {
            this.cancel();
        }
    }
    isPlanned() {
        return !!this.timerId;
    }
    debugLog(message) {
        (message !== undefined) && console.debug(message);
    }
}
